import { styled } from '@mui/system';
import { useMemo } from 'react';

import { UserCircleIcon } from '@app-velocity/icons';

export type CategoryIconProps = {
  category: 'accessible' | 'default';
};

const StyledIcon = styled('div')<{ iconColor: string }>(({ iconColor }) => ({
  display: 'flex',
  svg: {
    fill: iconColor,
  },
}));

export const CategoryIcon = ({ category }: CategoryIconProps) => {
  const color = useMemo(() => {
    switch (category) {
      case 'default':
        return '#2b6ff2';
      case 'accessible':
        return '#e95733';
      default:
        return '#2b6ff2';
    }
  }, [category]);

  return (
    <StyledIcon iconColor={color}>
      <UserCircleIcon />
    </StyledIcon>
  );
};
